var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.23077 9.46154C6.35284 9.46154 7.42895 9.0158 8.22238 8.22238C9.0158 7.42895 9.46154 6.35284 9.46154 5.23077C9.46154 4.1087 9.0158 3.03259 8.22238 2.23916C7.42895 1.44574 6.35284 1 5.23077 1C4.1087 1 3.03259 1.44574 2.23916 2.23916C1.44574 3.03259 1 4.1087 1 5.23077C1 6.35284 1.44574 7.42895 2.23916 8.22238C3.03259 9.0158 4.1087 9.46154 5.23077 9.46154Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9999 10.9999L8.30762 8.30762",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgSearch;